import { Typography } from 'aqui';
import { t } from 'i18next';
import { FunctionComponent } from 'react';
import { ChevronIcon } from 'aqui/icons';
import useSwitchPanel from '../../hooks/useSwitchPanel';
import useDataManagementProps from './useDataManagementProps';
import { DataManagementSection } from 'aq-data-management';

const DataManagementPanel: FunctionComponent = () => {
    const { backToPrevPanel } = useSwitchPanel();
    const props = useDataManagementProps();

    return (
        <div className="full-width flex flex-col">
            <div className="data-management-panel__header">
                <ChevronIcon
                    direction="left"
                    className="data-management-panel__back-btn"
                    onClick={backToPrevPanel}
                    dataTestId="data-management-back-btn"
                />
                <Typography type="h6">
                    {t('app-menu.data-management')}
                </Typography>
            </div>
            <div className="data-management-panel__content">
                <DataManagementSection {...props} />
            </div>
        </div>
    );
};

export default DataManagementPanel;
